import { markRaw } from 'vue'
import createMarker from './createMarker'

const updatePins = function (
    props,
    mapLocations,
    pins,
    markerThemeExtractor,
    currentMapTheme,
    highlightLocation,
    map

) {
    const hoverEnterLocation =
        props.hoverEnterLocation ??
        function (location) {
            highlightLocation.value = location
        }
    const hoverLeaveLocation =
        props.hoverLeaveLocation ??
        function () {
            highlightLocation.value = undefined
        }
    const clickLocation =
        props.clickLocation ??
        function (location) {
            if (location.externalUrl) {
                window.open(location.externalUrl, '_blank', 'noopener,noreferrer')
            }
            else {
                window.location.href = location.centerPageUrl
            }
        }

    mapLocations.value.forEach((location) => {
        pins.value.push({
            marker: markRaw(createMarker(
                location,
                markerThemeExtractor,
                currentMapTheme,
                hoverEnterLocation,
                hoverLeaveLocation,
                clickLocation,
                highlightLocation,
                map
            )),
            location,
        })
    })

    return pins.value
}

export default updatePins
